import React, { Component } from 'react';

class Title extends Component {
  render() {
    return (
      <h3 className="gm-slide__title" >{ this.props.text }</h3>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Shared/Title.js